export default {
  buttons: {
    add: 'Hinzufügen',
  },
  AddOn: {
    label: 'Add-on',
    title: 'Holen Sie sich Ihre mobile App',
    subscribed: 'Abonniert',
    cta: 'Mobile App holen',
    price_per_month: '{{price}} / Monat',
    tax_included: 'inkl. anfallender Steuer',
    apple_developer_note:
      'Erfordert einen Apple-Developer-Account (99 $/Jahr, zahlbar an Apple) auf die Firma des Restaurants.',
    features: {
      stores: 'Im App Store und bei Google Play gelistet',
      push: 'Push-Benachrichtigungen an Ihre Gäste',
      loyalty: 'Treuepunkte und Prämien',
      commission: 'Direktbestellung ohne Provision',
    },
  },
};
